<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'">
        <v-form @submit.prevent="send_wrap(idea)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL(improve_database_modal)">close</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Предложить улучшение базы знаний")}}</v-card-title>
            <v-layout mb-4 wrap>
                <v-flex sm6 xs12 :class="{'mb-4': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}">
                    <div class="grey-text mb-2">{{$t("Тема идеи")}}</div>
                    <v-select
                        solo
                        append-icon=""
                        :label="$t('Улучшение базы знаний')"
                        class="input"
                        disabled
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex sm6 xs12>
                    <div class="grey-text mb-2">{{$t("Название идеи")}} *</div>
                    <inputBase :class="{ 'form-group--error': $v.title.$error }" @change="idea_title($event.target.value)" />
                </v-flex>
            </v-layout>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Опишите Ваше предложение")}} *</div>
                    <textareaBase :placeholder="$t('Введите текст')" rows="4"
                                  required
                                  :class="{ 'form-group--error': $v.text.$error }" @change="idea_text($event.target.value)"
                    />
                </v-flex>
            </v-layout>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Загрузите файлы")}}</div>
                    <inputUpload id="logo_upload" :placeholder="$t('Загрузить файл...')" @input.native="send_files($event)" />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{ $t("Предложить") }}</buttonRed>
                    <div class="grey-text">{{$t("* - поля, обязательные для заполнения")}}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {required} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';

export default {
  components: {
    buttonRed,
    textareaBase,
    inputBase,
    inputUpload,
  },
  mixins     : [validationMixin],
  validations: {
    title: {
      required,
    },
    text: {
      required,
    },
  },
  data() {
    return {
      title: '',
      text : '',
      idea : {
        theme : 'База знаний',
        title : '',
        text  : '',
        files : [],
        errors: false,
      },
    };
  },
  computed: {
    ...mapGetters('database/modal', [
      'improve_database_modal',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    idea_title(ev) {
      this.title = ev;
      this.idea.title = ev;
      this.$v.title.$touch();
    },
    idea_text(ev) {
      this.text = ev;
      this.idea.text = ev;
      this.$v.text.$touch();
    },
    send_files($event) {
      let files = $event.target.files;
      for (let i=0; i<files.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = () => {
          this.idea.files.push(reader.result);
        };
      }
    },
    ...mapActions('ideas_bank', [
      'send_idea',
    ]),
    send_wrap(idea) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.errors = false;
        this.CLOSE_MODAL(this.improve_database_modal);
        this.send_idea(idea);
      }
    },
  },
};
</script>
